import {
  Button,
  Drawer,
  Popconfirm,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import Search from "antd/es/input/Search";
import React, { useState } from "react";
import useSWR from "swr";
import { fetcherhn } from "../../services/fectcher";
import { WarningOutlined } from "@ant-design/icons";
import { openNotification } from "../../common/elements/myNotification";
import { deleteNurseRequest } from "../../api/CareEventSCPApi";

import { NurseRequestAdd } from "./NurseRequestAdd";
import dayjs from "dayjs";
import { handleToggle } from "../../common/elements/toggleSeeMore";
import SendEmail from "../../common/elements/SendEmail";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { FiSend } from "react-icons/fi";

export const NurseRequest = (props) => {
  const intialReqState = {
    key: "",
    guid: "",
    mbi: props.mbiid,
    requestingNurseName: "",
    dateRequestSent: "",
    requestungDetails: "",
    createdBy: sessionStorage.getItem("userName"),
    modifiedBy: "",
  };

  const [editRecord, setEditRecord] = useState(intialReqState);
  const [query, setQuery] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, mutate, isLoading } = useSWR(
    `GetNurseRequest?id=${props.mbiid}`,
    fetcherhn
  );

  const handleCancel = (e) => {
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const handleModalClose = (e) => {
    setEditRecord(intialReqState);
    setMail(false);
  };
  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };
  const handleDelete = async (record) => {
    const body = { ...record, modifiedBy: sessionStorage.getItem("userName") };
    const deleteResult = await deleteNurseRequest(body);
    if (deleteResult.status) {
      mutate();
      openNotification(
        "success",
        "Deleted",
        "Nurse Request Template Deleted Successfully!"
      );
    }
    setEditRecord(intialReqState);
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const [mail, setMail] = useState(false);

  const sendDatatoEmail = (record) => {
    setMail(true);
    setEditRecord(record);
  };

  const columns = [
    {
      key: 1,
      title: "Name of Requesting Nurse",
      dataIndex: "requestingNurseName",
      width: 200,
    },
    {
      key: 2,
      title: "Date request was sent to team",
      dataIndex: "dateRequestSent",
      width: 150,
      render: (_, { dateRequestSent }) => (
        <div>
          {dayjs(dateRequestSent).format("YYYY-MM-DD") !== "1900-01-01" ? (
            dayjs(dateRequestSent).format("YYYY-MM-DD")
          ) : (
            <>
              {dayjs(dateRequestSent).format("YYYY-MM-DD")}
              <span className="tw-ml-2" style={{ color: "red" }}>
                <WarningOutlined />
              </span>
            </>
          )}
        </div>
      ),
    },
    {
      key: 3,
      title: "Request Details",
      dataIndex: "requestungDetails",
      render: (text, record) => {
        const isExpanded = expandedRows.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: 4,
      title: "Created By",
      dataIndex: "createdBy",
      width: 150,
      render: (createdBy) => <div>{createdBy.split("@")[0]}</div>,
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 110,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Send Email">
              <FiSend
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => sendDatatoEmail(record)}
                color="green"
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data.filter((item) => {
        return [
          "requestingNurseName",
          "dateRequestSent",
          "requestungDetails",
          "createdBy",
        ].some((key) =>
          (item[key]?.toString()?.toLowerCase() ?? "").includes(
            query?.toLowerCase() ?? ""
          )
        );
      })
    : data;

  if (isLoading) {
    return <Skeleton active={isLoading} />;
  }

  return (
    <div>
      <div className="tw-flex tw-justify-between ">
        <p
          className="pt-3"
          style={{
            color: "#D2691E",
            fontWeight: "600",
          }}
        >
          Nurse Request Template
        </p>

        <div className="tw-flex tw-justify-end  tw-mt-3 ">
          <Space>
            <Search
              className=" tw-mb-4"
              size="middle"
              placeholder="Search"
              onChange={(e) => setQuery(e.target.value)}
              allowClear
            />
            <Button
              type="primary"
              onClick={() => setIsModalOpen(true)}
              className="tw-mb-4 "
            >
              Add
            </Button>
          </Space>
        </div>
      </div>
      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title={"Add/Update Nurse Request Template"}
          onClose={handleCancel}
          width={900}
        >
          <NurseRequestAdd callback={handleOk} editRecord={editRecord} />
        </Drawer>
      )}
      <Table
        bordered
        size="middle"
        dataSource={finalResult}
        columns={columns}
      />
      {mail && (
        <SendEmail
          open={mail}
          close={handleModalClose}
          editRecord={editRecord}
          modalTitle={"Nurse Request Template"}
          patientName={props?.patient?.label}
        />
      )}
    </div>
  );
};
